export default __webpack_public_path__ + "static/media/videos-icon.171c6302.svg";